import { Component } from '@angular/core'
import { RushMainService } from '@rush-shared/services/rush-main.service'
import { TabNamesEnums } from '@rush-shared/enums'
import { MechanicsComponent } from './mechanics/mechanics.component'
import { CoinComponent } from './coin/coin.component'
import { ProfileComponent } from '@shared/components'
import { AutoBetSettingsComponent } from '@src/app/inbetween/rush-components/rush-other-page-content/auto-bet-settings/auto-bet-settings.component'

@Component({
  selector: 'app-rush-other-page-content',
  standalone: true,
  imports: [
    MechanicsComponent,
    CoinComponent,
    ProfileComponent,
    AutoBetSettingsComponent,
  ],
  templateUrl: './rush-other-page-content.component.html',
  styleUrl: './rush-other-page-content.component.sass',
})
export class RushOtherPageContentComponent {
  tabNamesEnums = TabNamesEnums

  get title(): string {
    return this._rushMainService.activeTab$.value?.title || ''
  }
  get activeTab() {
    return this._rushMainService.activeTab$.value
  }

  constructor(private _rushMainService: RushMainService) {}

  close() {
    this._rushMainService.goToPrevTab()
  }
}
